import './eastcoastpizza/style';
import FormStructure from './eastcoastpizza/form_structure';

export default FormStructure;